import { useQuery } from "@tanstack/react-query";

import { COMMON_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

// 게시글 상세 조회
export const useGetBoard = (category: string, idx: string, options: { enabled: boolean }) => {
    return useQuery({
        queryKey: ["boardDetail", category, idx],
        queryFn: async () => {
            const res = await consoleAxios.get(
                `${COMMON_API_ROUTES.BOARD_DETAIL.replace(":category", category).replace(":idx", idx)}?pass=T`,
            );
            return res.data;
        },
        enabled: options.enabled,
    });
};
